import { IDeleteItensChecklistUseCase } from "../../../presentation/useCases/delete/delete_itens_checklist_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class DeleteItensChecklistUseCase implements IDeleteItensChecklistUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteItensChecklist(IdItemChecklist: number): Promise<void> {
    await this.repository.deleteItensChecklist(IdItemChecklist);
  }
}
